// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"8d09d428","453":"1bf9140e"}[chunkId] + ".chunk.js";
};